import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import axios from 'axios';
// Vuex modules + Vuex ORM models
import Category from '@/modules/category/store/model';
import Alert from '@/modules/alerts/store/model';
import Event from '@/modules/event/store/model';
import Task from '@/modules/task/store/model';
import Member from '@/modules/member/store/model';
import Device from '@/modules/device/store/model';
import MemberDeviation from '@/modules/member-deviation/store/model';
import jwtDecode from 'jwt-decode';
import { keycloak } from '@/globals/helpers/keycloak-init';
import authentication from './modules/authentication';

Vue.use(Vuex);

const umaAxios = axios.create();
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
function getUmaToken(accessToken) {
  const headers = {
    authorization: `Bearer ${accessToken}`,
    'content-Type': 'application/x-www-form-urlencoded',
  };

  return new Promise((resolve, reject) => {
    umaAxios.post(
      keycloak.endpoints.token(),
      `grant_type=urn:ietf:params:oauth:grant-type:uma-ticket&client_id=${process.env.VUE_APP_KEYCLOAK_CLIENTID}&audience=api-service`,
      {
        headers,
      },
    ).then((response) => {
      localStorage.setItem('uma-token', response.data.access_token);
      resolve();
    }).catch(() => {
      reject();
    });
  });
}

function umaTokenIsExpired() {
  const token = localStorage.getItem('uma-token');
  if (!token) return true;
  // If uma token has less than 5 seconds left before expiring, consider token expired
  return (jwtDecode(token).exp - Math.floor(Date.now() / 1000) + keycloak.timeSkew) <= 5;
}

// Vuex ORM Axios Headers option does not allow dynamic header
// using axios interceptor to dynamically update global header with UMA token
api.interceptors.request.use(async (config) => {
  if (umaTokenIsExpired()) {
    await getUmaToken(keycloak.token);
  }
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${localStorage.getItem('uma-token')}`;
  return config;
});

api.interceptors.response.use((res) => Promise.resolve(res), (err) => {
  if (err?.response?.data?.error) {
    // eslint-disable-next-line no-use-before-define
    store.commit('setToast', {
      message: err?.response?.data?.error,
      config: { type: 'error' },
    });
  }
  return Promise.reject(err);
});

VuexORM.use(VuexORMAxios, {
  axios: api,
  baseURL: process.env.VUE_APP_API_URL,
});
const database = new VuexORM.Database();

// register Vuex ORM models
database.register(Category);
database.register(Event);
database.register(Task);
database.register(Member);
database.register(MemberDeviation);
database.register(Alert);
database.register(Device);

const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state: {
    selectedGroup: null,
  },
  mutations: {
    setGroup(state, payload) {
      state.selectedGroup = payload;
    },
    setToast(state, payload) {
      // used only for subscribing to addToast in App.vue
      return payload;
    },
  },
  actions: {
  },
  modules: {
    authentication,
  },
});

export { store, api };
